module.exports = __webpack_public_path__ + "static/media/fa-brands-400.073c2f3c.svg";